var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBusinessOverdraft40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.0833333,12.9166645 C21.0833333,14.0779161 20.27817,15 19.2658033,15 L1.81753,15 C0.805163333,15 0,14.0779161 0,12.9166645 L0,2.08333548 C0,0.922916129 0.805163333,0 1.81753,0 L19.2658033,0 C20.27817,0 21.0833333,0.922916129 21.0833333,2.08333548 L21.0833333,12.9166645 L21.0833333,12.9166645 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83333333,8 C5.95042583,8 7.66666667,6.20914 7.66666667,4 C7.66666667,1.79086 5.95042583,0 3.83333333,0 C1.71624083,0 0,1.79086 0,4 C0,6.20914 1.71624083,8 3.83333333,8 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83333333,8 C5.9504237,8 7.66666667,6.20913778 7.66666667,4 C7.66666667,1.79086222 5.9504237,0 3.83333333,0 C1.71624296,0 0,1.79086222 0,4 C0,6.20913778 1.71624296,8 3.83333333,8 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Overdraft40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overdraft"
  }, /*#__PURE__*/React.createElement("g", {
    id: "picto",
    transform: "translate(8.500000, 12.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "-2.29166667 -2.41935484 23.375 -2.41935484 23.375 17.4193548 -2.29166667 17.4193548"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0833333,12.9166645 C21.0833333,14.0779161 20.27817,15 19.2658033,15 L1.81752862,15 C0.805165167,15 0,14.0779161 0,12.9166645 L0,2.08333355 C0,0.922916613 0.805165167,0 1.81752862,0 L19.2658033,0 C20.27817,0 21.0833333,0.922916613 21.0833333,2.08333355 L21.0833333,12.9166645 L21.0833333,12.9166645 Z",
    id: "Stroke-4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.375,
    y1: 4,
    x2: 3.20833333,
    y2: 4,
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.208333,
    y1: 6,
    x2: 9.16666667,
    y2: 6,
    id: "Stroke-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-8-Clipped",
    transform: "translate(12.416667, 8.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-4)",
    points: "-2.49107143 -2.5 9.9672619 -2.5 9.9672619 10.5 -2.49107143 10.5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.25,16 C18.3670925,16 20.0833333,14.20914 20.0833333,12 C20.0833333,9.790861 18.3670925,8 16.25,8 C14.1329085,8 12.4166667,9.790861 12.4166667,12 C12.4166667,14.20914 14.1329085,16 16.25,16 Z",
    id: "Stroke-11",
    stroke: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-12-Clipped",
    transform: "translate(15.333333, 7.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#FFCC00",
    fillRule: "nonzero",
    mask: "url(#mask-6)",
    points: "-2.43386243 -2.22222222 11.1957672 -2.22222222 11.1957672 10.2222222 -2.43386243 10.2222222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(15.333333, 7.000000)",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.83333333,8 C5.9504237,8 7.66666667,6.20913778 7.66666667,4 C7.66666667,1.79086089 5.9504237,0 3.83333333,0 C1.71624169,0 0,1.79086089 0,4 C0,6.20913778 1.71624169,8 3.83333333,8 Z",
    id: "Stroke-15"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBusinessOverdraft40);
export default __webpack_public_path__ + "static/media/pictogramBusinessOverdraft40.01f6675d77e413049cfd42d8ac28d019.svg";
export { ForwardRef as ReactComponent };